import { domToBlob } from 'modern-screenshot'
import { FORMAT_DIMENSIONS } from '../ShareCard/shareCardTokens'
import { ShareCardFormat } from '../ShareCard/ShareCard.types'

/**
 * Rasterizes a ShareCard node that is rendered at exactly the format's pixel width, so
 * its `cqw` units resolve to the same pixels as the spec and the PNG matches the preview.
 *
 * modern-screenshot rather than html-to-image: html-to-image rounds every font size down
 * (`floor(px) - 0.1`), which shrinks the card's fractional cqw sizes enough to rewrap text.
 */
export async function rasterizeShareCard(node: HTMLElement, format: ShareCardFormat): Promise<Blob> {
  await document.fonts.ready
  const { width, height } = FORMAT_DIMENSIONS[format]
  return domToBlob(node, { width, height, scale: 1, type: 'image/png' })
}
